<script setup lang="ts">
definePageMeta({ layout: 'bare' })
useHead({ title: 'Log in — Regotiate' })
</script>

<template>
  <AuthForm mode="login" />
</template>
